export const sources = {
	webp: "__VITE_ASSET__7PUm3F_uVf$21BIFLSklvQ__ 500w, __VITE_ASSET___ewJD0zO9$SsiDvawfmAUw__ 800w, __VITE_ASSET__hO4dd8ILk$iZF7aFIOUkdg__ 1080w, __VITE_ASSET__m8R6TgWxwop2r_xOIPNRtg__ 1600w, __VITE_ASSET__cLZLOsSELI_GmwKcVOKKRw__ 2000w, __VITE_ASSET__pADEGV0e5Qot5ZhzD_GrLg__ 2600w, __VITE_ASSET__SH3JcDOvWNcn2WIvxBnLpg__ 3200w, __VITE_ASSET__K1daVVNYU_lXF$FdA5v55g__ 3881w"
};
export const img = {
	src: "__VITE_ASSET__K1daVVNYU_lXF$FdA5v55g__",
	w: 3881,
	h: 4924
};
export default {
	sources: sources,
	img: img
};
